import React, { useState } from "react";
import { Paper, Button, Typography, makeStyles } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
	container: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(4),
		backgroundColor: "#f5f5f5",
		minHeight: 300,
		textAlign: "center",
		borderRadius: 0,
	},
	icon: {
		fontSize: 64,
		color: "#DC143C",
		marginBottom: theme.spacing(2),
	},
	text: {
		fontSize: 18,
		color: "#303030",
		fontWeight: 500,
		marginBottom: theme.spacing(3),
	},
	subtitle: {
		fontSize: 13,
		color: "#666",
		marginBottom: theme.spacing(2),
	},
	button: {
		marginTop: theme.spacing(2),
		minWidth: 160,
	},
}));

const BlacklistedView = ({ contactId, connection, onUnblocked }) => {
	const classes = useStyles();
	const [loading, setLoading] = useState(false);

	const handleUnblock = async () => {
		if (!contactId || loading) return;
		setLoading(true);
		try {
			await api.delete("/blacklist/by", {
				params: {
					contactId,
					connection: connection != null ? connection : ""
				}
			});
			toast.success("Contato desbloqueado.");
			if (onUnblocked) onUnblocked();
		} catch (err) {
			toastError(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Paper elevation={0} square className={classes.container}>
			<BlockIcon className={classes.icon} />
			<Typography className={classes.text}>
				Este contato está na blacklist
			</Typography>
			<Typography className={classes.subtitle}>
				As mensagens estão temporariamente ocultas. O histórico foi preservado.
			</Typography>
			<Button
				variant="contained"
				color="primary"
				onClick={handleUnblock}
				disabled={loading || !contactId}
				className={classes.button}
			>
				{loading ? "Desbloqueando..." : "Desbloquear"}
			</Button>
		</Paper>
	);
};

export default BlacklistedView;
